import { render, staticRenderFns } from "./LegendCtrl.vue?vue&type=template&id=44fd1472&"
import script from "./LegendCtrl.vue?vue&type=script&lang=js&"
export * from "./LegendCtrl.vue?vue&type=script&lang=js&"
import style0 from "./LegendCtrl.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports